<template>
	<router-link
		class="eia-link"
		v-if="to"
		:to="to">
		<span><slot></slot></span>
	</router-link>

	<a class="eia-link"
		v-else
		:href="href"
		@click="onClick"
		:target="isExternal ? '_blank' : ''">
		<span><slot></slot></span>
		<i v-if="isExternal"
			class="eia-link__external-icon">
		</i>
	</a>
</template>

<script>
export default {
	name: 'eia-link',
	props: {
		href: {
			type: String,
			required: false,
		},

		to: {
			type: Object,
			required: false,
		},
	},

	computed: {
		isExternal() {
			if( !this.href ) {
				return;
			}

			return this.href.indexOf( 'http' ) === 0;
		},
	},

	methods: {
		onClick( e ) {

			if( !this.to && !this.href ) {
				e.stopPropagation();
				e.preventDefault();
			}

			this.$emit( 'click', ...arguments );
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-link {
	display: inline-block;
	color: $color-primary;
	text-decoration: none;
	cursor: pointer;

	span {
		text-decoration: underline;
		text-decoration-skip-ink: auto;
	}

	&:hover {
		color: mix( $color-main, $color-primary, 25 );
	}

	&:focus {
		color: mix( $color-main, $color-primary, 25 );
	}

	.eia-link__external-icon {
		display: inline-block;
		position: relative;
		width: 1em;
		height: 0.75em;
		text-decoration: none;
		font-style: normal;
		transform: translate3d( 0, -0.125em, 0 );

		&:before {
			position: absolute;
			top: 0;
			right: 0;
			// bottom: -1.25em;
			// left: -0.175em;
			transform: translate3d( -20%, 25%, 0 );
			content: '\2514';
		}

		&:after {
			position: absolute;
			transform: translate3d( 0, -15%, 0 );
			top: 0;
			right: 0;
			content: '\2B08';
		}
	}
}
</style>
